<template>
  <v-app>
    <core-toolbar />
    <!-- <navigation-drawer /> -->
    <router-view />
    <cgi-snackbar />
    <cgi-alert />
  </v-app>
</template>

<script>
export default {
  mounted() {
    this.$vuetify.lang.current = window["local"].split("-")[0];
  },
};
</script>


<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  text-align: center;
}
</style>
